import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import router from './router';
import { RouterProvider } from 'react-router-dom';
import { initSentry } from './lib/sentry';
import { getRouterPageUrl, trackPageView } from './lib/analytics';

initSentry();
trackPageView();
router.subscribe((state) => {
  const pageUrl = getRouterPageUrl(state, window.location.origin);
  if (pageUrl) trackPageView(pageUrl);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
